import {
  Component,
  OnInit,
  Renderer2,
  enableProdMode,
  inject,
} from '@angular/core';
import {
  Event,
  NavigationEnd,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { environment } from '../environments/environment';
import { ThemeService } from './services/theme.service';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PreRenderComponent } from './components/shared/pre-render/pre-render.component';
import { RenderModeService } from './services/render-mode';
import { MetadataSportService } from './services/seo';

if (environment.production) {
  enableProdMode();
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TranslateModule, CommonModule, PreRenderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private renderMode = inject(RenderModeService);
  private metadataSportService = inject(MetadataSportService);

  // signal
  isBrowser = this.renderMode.isBrowser;

  title = 'Resultados de fútbol en vivo y partidos hoy en Marcadores247.com';

  constructor(
    private themeService: ThemeService,
    private renderer: Renderer2,
    private readonly router: Router
  ) {
    if (this.isBrowser()) {
      this.metadataSportService.getMetadataList();
      this.router.events.subscribe((event: Event) => {
        if (
          event instanceof NavigationEnd ||
          event instanceof NavigationStart
        ) {
          if (
            !event.url.includes('matchtracker-live') &&
            !event.url.includes('sports-live')
          ) {
            if (!event.url.includes('/partido/')) this.loadScriptTags();
            else if (event.url.includes('/partido/'))
              this.loadScriptTagsDetail();
          }
        }
      });
    }
  }

  ngOnInit(): void {
    if (this.isBrowser()) {
      window.scrollTo(0, 0);
      this.themeService.initializeTheme();
    }
  }

  loadScriptTags(): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = './assets/js/tags.js';
    script.id = 'clever-core';
    script.CDATA_SECTION_NODE;
    script.async = true;
    script.defer = false;
    this.renderer.appendChild(document.body, script);
    return script;
  }

  loadScriptTagsDetail(): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = './assets/js/tags-clever.js';
    script.id = 'clever-core';
    script.CDATA_SECTION_NODE;
    script.async = false;
    this.renderer.appendChild(document.body, script);
    return script;
  }
}
